export interface GapStylingConfig {
  enabled: boolean;
  height: number;
  backgroundType: 'color' | 'gradient' | 'image' | 'pattern';
  backgroundColor: string;
  gradientType: 'linear' | 'radial' | 'conic';
  gradientDirection: string;
  gradientColors: Array<{ color: string; position: number }>;
  backgroundImage: string;
  imageRepeat: 'repeat' | 'repeat-x' | 'repeat-y' | 'no-repeat';
  imageSize: 'auto' | 'cover' | 'contain' | 'custom';
  imageSizeWidth: string;
  imageSizeHeight: string;
  imagePosition: string;
  patternType: 'dots' | 'stripes' | 'waves' | 'checkerboard' | 'zigzag';
  patternColor: string;
  patternSecondaryColor: string;
  patternSize: number;
  opacity: number;
  borderRadius: number;
  borderWidth: number;
  borderColor: string;
  borderStyle: 'solid' | 'dashed' | 'dotted' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset';
  boxShadow: {
    enabled: boolean;
    x: number;
    y: number;
    blur: number;
    spread: number;
    color: string;
    inset: boolean;
  };
  animation: {
    enabled: boolean;
    type: 'none' | 'pulse' | 'glow' | 'slide' | 'fade' | 'bounce' | 'rotate';
    duration: number;
    infinite: boolean;
  };
  margin: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  blendMode: 'normal' | 'multiply' | 'screen' | 'overlay' | 'darken' | 'lighten' | 'color-dodge' | 'color-burn' | 'hard-light' | 'soft-light' | 'difference' | 'exclusion';
}

export interface GapStylingComponentProps {
  config: GapStylingConfig;
  onConfigChange: (config: GapStylingConfig) => void;
  onSave?: (config: GapStylingConfig) => Promise<void>;
}

export const defaultConfig: GapStylingConfig = {
  enabled: false,
  height: 20,
  backgroundType: 'color',
  backgroundColor: '#f5f5f5',
  gradientType: 'linear',
  gradientDirection: '90deg',
  gradientColors: [
    { color: '#ff6b6b', position: 0 },
    { color: '#4ecdc4', position: 100 }
  ],
  backgroundImage: '',
  imageRepeat: 'no-repeat',
  imageSize: 'cover',
  imageSizeWidth: '100%',
  imageSizeHeight: '100%',
  imagePosition: 'center',
  patternType: 'dots',
  patternColor: '#e0e0e0',
  patternSecondaryColor: '#ffffff',
  patternSize: 10,
  opacity: 1,
  borderRadius: 0,
  borderWidth: 0,
  borderColor: '#cccccc',
  borderStyle: 'solid',
  boxShadow: {
    enabled: false,
    x: 0,
    y: 2,
    blur: 4,
    spread: 0,
    color: '#00000040',
    inset: false,
  },
  animation: {
    enabled: false,
    type: 'none',
    duration: 2,
    infinite: true,
  },
  margin: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  blendMode: 'normal',
};